import SecretaryImage from '../assets/images/chairman.png'; // Adjust the path as needed

const SecretarySection = ({hideElem}) => { 
  return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">
        {!hideElem && (
          <div className="row justify-content-center mt-3 pb-4">
            <div className="col-md-12  heading-section ftco-animate text px-4">
              <h2 className="mb-4 text-success text-center">
               Management Team
              </h2>
            </div>
          </div>
        )}

        <div className="row mt-3">
          <div className=" col-md-12 order-md-first">
            <div className="text px-4">
              <h2 className="mb-4 text-secondary"> Secretary’s Message </h2>
              <p>
              Dear Parents, Students, and Staff,<br/>
              <img src={SecretaryImage} alt="SRN Chairman" className="img-fluid" width={400} height={200} />
       
            It is with great pleasure that I welcome you all to another exciting year at [School Name]. As the secretary of this wonderful institution, I am here to ensure smooth communication between the school and our families, as well as assist with any administrative needs that may arise.</p>

              <p>Our school is committed to providing an environment where every student can thrive academically, socially, and emotionally. We value the collaboration between our staff, students, and parents, and I encourage you to reach out for any support or information.</p>

              <p>Together, let’s work towards making this academic year a memorable and successful one for our students.</p>

              <p>Thank you for your continued trust and support.  </p> 
            </div>
            <h5 className='font-weight-bold px-4'>Shri. R. Sasi Kumar <span className="qualification">M.A B.Ed</span> <br />Secretary</h5>
             
          </div>
        </div>  
      </div>  
      <hr className="custom-hr"/>
    </section>
  );
};

export default SecretarySection;
